/**
 * Canonical daily goal defaults.
 *
 * These must match `backend/models/DailySummarySections.js` (manualMetricsSchema)
 * and `FastTime/lib/models/daily_habit_metrics.dart`. The dashboard used to
 * default water to 2.5 L and exercise to 1 h while both other surfaces used
 * 2.0 and 2.5, so the same stored data produced different progress rings
 * depending on where the user looked.
 */
export const DEFAULT_WATER_GOAL_L = 2.0;
export const DEFAULT_STEPS_GOAL = 10000;
export const DEFAULT_EXERCISE_GOAL_H = 2.5;

// A goal of 0 is not a goal — it is an unset field, and using it as a
// denominator produces NaN or Infinity in every progress calculation.
const positiveOr = (...candidates) => {
  for (const candidate of candidates) {
    if (typeof candidate === 'number' && Number.isFinite(candidate) && candidate > 0) {
      return candidate;
    }
  }
  return null;
};

/**
 * Resolve the goals to render for a day: the day's own record first, then the
 * user's saved preferences, then the canonical defaults.
 */
export function resolveGoals({ habits, preferences } = {}) {
  return {
    waterGoal: positiveOr(habits?.waterGoal, preferences?.waterGoal) ?? DEFAULT_WATER_GOAL_L,
    stepsGoal: positiveOr(habits?.stepsGoal, preferences?.stepsGoal) ?? DEFAULT_STEPS_GOAL,
    exerciseGoal: positiveOr(habits?.exerciseGoal, preferences?.exerciseGoal) ?? DEFAULT_EXERCISE_GOAL_H,
  };
}
